import React from 'react';
import { useSelector } from "react-redux";

// Components
import { ConversationNotifications } from '../modules/conversation-notifications/conversation-notifications';

// Styles
import './chat-status-not-answered.scss';

// Store entities
import { getGlobalConfigState } from "../../../store/global-config/global-config.selectors";

export const ChatStatusNotAnswered = () => {

  const { businessTerms } = useSelector(getGlobalConfigState);

  const workerId = localStorage.getItem('worker_id');
  const returnPathname = localStorage.getItem('return_pathname') ?? `/expert/${ workerId }`;

  return (<ConversationNotifications
    title={ 'No Answer' }
    text={ `We apologize for the inconvenience. The ${ businessTerms.Consultant } could not respond to your connection, but rest assured that the payment for the Text Chat will be refunded to you.` }
    navigateAction={ returnPathname }/>);
}
